import { render, staticRenderFns } from "./transportContentAutoManage.vue?vue&type=template&id=4e96d9ad&scoped=true"
import script from "./transportContentAutoManage.vue?vue&type=script&lang=js"
export * from "./transportContentAutoManage.vue?vue&type=script&lang=js"
import style0 from "./transportContentAutoManage.vue?vue&type=style&index=0&id=4e96d9ad&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e96d9ad",
  null
  
)

export default component.exports